import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import footerLogo from '../assets/images/footer logo.png';
import securityImg from '../assets/images/footer/security.png';
import uptimeImg from '../assets/images/footer/uptime.png';
import monitoringImg from '../assets/images/footer/24-7.png';
import cloudImg from '../assets/images/footer/cloud.png';

function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleNewsletter = (e) => {
    e.preventDefault();
    setSubscribed(true);
    setEmail('');
  };

  return (
    <footer style={{ backgroundColor: '#b2e7fa' }} className="text-dark pt-5 pb-3">
      <div className="container">

        {/* NEWSLETTER STRIP */}
        <div className="row mb-5">
          <div className="col-lg-10 mx-auto">
            <div className="p-4 rounded bg-white shadow-sm text-center">
              <h5 className="fw-bold mb-2">Stay Ahead with DDevOps</h5>
              <p className="small text-muted mb-3">Get infrastructure insights, DevOps best practices & updates. No spam. Ever.</p>
              <form className="row g-2 justify-content-center" onSubmit={handleNewsletter}>
                <div className="col-md-6 col-sm-8">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter your business email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-3 col-sm-4">
                  <button type="submit" className="btn btn-info text-white w-100">Subscribe</button>
                </div>
              </form>
              {subscribed && (
                <p className="small text-success mt-3">✔ Thank you for subscribing. We'll keep it valuable & spam-free.</p>
              )}
            </div>
          </div>
        </div>

        {/* TRUST BADGES */}
        <div className="row text-center mb-5">
          <div className="col-md-3 col-6 mb-4">
            <img src={securityImg} alt="Security" width="50" className="mb-2" />
            <div className="fw-bold small">ISO-Ready Security</div>
            <div className="text-muted small">Best Practices</div>
          </div>
          <div className="col-md-3 col-6 mb-4">
            <img src={uptimeImg} alt="SLA" width="50" className="mb-2" />
            <div className="fw-bold small">SLA Driven</div>
            <div className="text-muted small">Guaranteed Uptime</div>
          </div>
          <div className="col-md-3 col-6 mb-4">
            <img src={monitoringImg} alt="Monitoring" width="50" className="mb-2" />
            <div className="fw-bold small">24/7 Monitoring</div>
            <div className="text-muted small">Always On</div>
          </div>
          <div className="col-md-3 col-6 mb-4">
            <img src={cloudImg} alt="Cloud" width="70" className="mb-2" />
            <div className="fw-bold small">Cloud Native</div>
            <div className="text-muted small">AWS • GCP • Azure</div>
          </div>
        </div>

        {/* MAIN FOOTER */}
        <div className="row gy-5 g-5 align-items-start">

          {/* Brand */}
          <div className="col-lg-4 col-md-12">
            <Link to="/">
              <img src={footerLogo} loading="lazy" alt="DDevOps Footer Logo" style={{ width: '170px' }} className="mb-4" />
            </Link>
            <p className="small mb-3">We believe in merit, quality and excellence.</p>
            <p className="small mb-2"><strong>info@ddevops.com</strong></p>
            <p className="small mb-2">
              <a href="tel:+923023338677" className="text-info fw-bold text-decoration-none">+92 302 333 8677</a><br />
              <strong>(DDEVOPS)</strong>
            </p>
            <p className="small mb-0"><strong>Location:</strong> Karachi, Pakistan</p>
          </div>

          {/* Services */}
          <div className="col-lg-2 col-md-4 col-sm-6">
            <h6 className="fw-bold mb-3">Services</h6>
            <ul className="list-unstyled small">
              <li className="mb-2"><Link to="/devops-services" className="text-dark text-decoration-none">DevOps</Link></li>
              <li className="mb-2"><Link to="/devsecops-services" className="text-dark text-decoration-none">SecOps</Link></li>
              <li className="mb-2"><Link to="/managed-services" className="text-dark text-decoration-none">Managed Services</Link></li>
            </ul>
          </div>

          {/* Partnership */}
          <div className="col-lg-2 col-md-4 col-sm-6">
            <h6 className="fw-bold mb-3">Partnership</h6>
            <ul className="list-unstyled small">
              <li className="mb-2"><Link to="/technology-partnership" className="text-dark text-decoration-none">Technology Partnership</Link></li>
              <li className="mb-2"><Link to="/whitelabel-solution" className="text-dark text-decoration-none">Whitelabel Solution</Link></li>
              <li className="mb-2"><Link to="/coming-soon" className="text-dark text-decoration-none">Adons</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-4 col-sm-6">
            <h6 className="fw-bold mb-3">Quick Links</h6>
            <ul className="list-unstyled small">
              <li className="mb-2"><a href="https://dashboard.ddevops.com/" className="text-dark text-decoration-none">Customer Login</a></li>
              <li className="mb-2"><Link to="/privacy-policy" className="text-dark text-decoration-none">Privacy Policy</Link></li>
              <li className="mb-2"><Link to="/terms" className="text-dark text-decoration-none">Terms</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div className="col-lg-2 col-md-4 col-sm-6">
            <h6 className="fw-bold mb-3">Support</h6>
            <ul className="list-unstyled small">
              <li className="mb-2"><a href="https://support.ddevops.com/hc/en-us" className="text-dark text-decoration-none">Help & FAQ</a></li>
              <li className="mb-2"><a href="https://support.ddevops.com/hc/en-us" className="text-dark text-decoration-none">Support Ticket</a></li>
              <li className="mb-2"><Link to="/contact" className="text-dark text-decoration-none">Contact</Link></li>
            </ul>
          </div>

        </div>

        {/* BOTTOM BAR */}
        <div className="border-top border-dark mt-5 pt-4 d-flex flex-column flex-md-row justify-content-between align-items-center">
          <p className="small mb-3 mb-md-0">© 2026 DDevOps.com. All rights reserved.</p>
          <div className="d-flex gap-4 fs-4">
            <a href="https://www.facebook.com/DedicatedDevOps/" target="_blank" rel="noreferrer" className="text-dark">
              <iconify-icon icon="mdi:facebook"></iconify-icon>
            </a>
            <a href="https://www.linkedin.com/company/dedicateddevops/" target="_blank" rel="noreferrer" className="text-dark">
              <iconify-icon icon="mdi:linkedin"></iconify-icon>
            </a>
            <a href="https://www.instagram.com/ddevops_academy/" target="_blank" rel="noreferrer" className="text-dark">
              <iconify-icon icon="mdi:instagram"></iconify-icon>
            </a>
            <a href="https://www.youtube.com/@DedicatedDevOps" target="_blank" rel="noreferrer" className="text-dark">
              <iconify-icon icon="mdi:youtube"></iconify-icon>
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
